import { useState, useEffect } from 'react';
import { Cookie, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const COOKIE_CONSENT_KEY = 'protectcord_cookie_consent';

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Small delay so it doesn't flash on page load
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[60] p-4 sm:p-6">
      <div className="max-w-4xl mx-auto bg-dark-card/95 backdrop-blur-xl border border-white/[0.08] rounded-xl shadow-2xl shadow-black/40 p-6 animate-in">
        <div className="flex flex-col sm:flex-row items-start gap-4">
          <div className="p-2 bg-primary-500/10 rounded-lg flex-shrink-0 hidden sm:block">
            <Cookie className="w-6 h-6 text-primary-400" />
          </div>
          <div className="flex-1">
            <h3 className="text-dark-text font-medium mb-1">Cookie Notice</h3>
            <p className="text-dark-muted text-sm">
              We use essential cookies for authentication and session management. We also use analytics
              cookies to understand how you use our service and improve your experience. Read more in our{' '}
              <Link to="/privacy" className="text-primary-400 hover:underline">
                Privacy Policy
              </Link>.
            </p>
          </div>
          <div className="flex items-center gap-3 flex-shrink-0 w-full sm:w-auto">
            <button
              onClick={handleDecline}
              className="flex-1 sm:flex-initial px-4 py-2 text-sm text-dark-muted hover:text-dark-text border border-white/[0.06] hover:bg-dark-800/60 rounded-xl transition-colors"
            >
              Decline
            </button>
            <button
              onClick={handleAccept}
              className="flex-1 sm:flex-initial btn-primary px-4 py-2 text-sm"
            >
              Accept All
            </button>
          </div>
          <button
            onClick={handleDecline}
            className="absolute top-3 right-3 sm:hidden p-1 text-dark-muted hover:text-dark-text"
            aria-label="Close"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
